import type { StageConfig } from '@capture/shared';
import { StageDeepLinks } from './StageDeepLinks';

export function PostOcrPanel({ config, onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const fieldValidationPolicy = (config.config.fieldValidationPolicy as string) ?? 'warn';
  return (
    <div className="stage-panel">
      <label>
        Field validation policy
        <select
          value={fieldValidationPolicy}
          onChange={(e) => onChange({ ...config, config: { ...config.config, fieldValidationPolicy: e.target.value } })}
        >
          <option>warn</option>
          <option>reject</option>
          <option>skip</option>
        </select>
      </label>
      <StageDeepLinks stage="post-ocr" />
    </div>
  );
}
